import _Promise from "@babel/runtime-corejs3/core-js/promise";
export const registerServiceWorker = async serviceWorkerAbsolutePath => {
  if ("serviceWorker" in navigator) {
    return new _Promise(resolve => {
      navigator.serviceWorker.register(serviceWorkerAbsolutePath).then(serviceWorkerRegistration => resolve(serviceWorkerRegistration));
    });
  }
};
export const getFirebaseServiceWorker = async () => {
  return registerServiceWorker("./firebase-messaging-sw.js");
};